import { FONT, larger, light_smaller } from './Design.js';
import { GAME_VERSION } from './State.js';

export class GameOverScene extends Phaser.Scene {

    constructor ()
    {
        super({ key: 'GameOverScene', active: false });
    }
    
    // TODO support single player on this screen
    init(data) {
        this.gameType = data.gameType;
        this.score = data.playerOne.count + " : " + data.playerTwo.count
    }

    create() {
		this.add.image(400, 300, 'sky');
        this.add.image(this.game.canvas.width/2-40, this.game.canvas.height/2,'gameover');
        this.add.text(16, 16, this.score, larger);
        this.add.text(16, 116, 'Game Type: ' + this.gameType, FONT);
        
        this.add.text(750,580, 'v.'+GAME_VERSION, light_smaller)

        this.game.destroy(false);
    }
}